/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Submit_UrlsInputs */

const en_admin_indexnow_submit_urls = /** @type {(inputs: Admin_Indexnow_Submit_UrlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit these URLs`)
};

/**
* | output |
* | --- |
* | "Submit these URLs" |
*
* @param {Admin_Indexnow_Submit_UrlsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_submit_urls = /** @type {((inputs?: Admin_Indexnow_Submit_UrlsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Submit_UrlsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_submit_urls(inputs)
});
export { admin_indexnow_submit_urls as "admin.indexnow.submit_urls" }